<script setup>
import { useRoute, useRouter } from "vue-router";
import ProyectsTable from "../../components/Proyects/ProyectsTable.vue";

const route = useRoute();
const router = useRouter();
console.log("RUTA EDIT PROYECT PAPA");

const goToCreateProyect = () => {
  router.push({ name: 'DashboardProyectCreate' });
};
</script>
<template>
  <div class="">
    <div class="d-flex justify-content-between align-items-center my-3">
      <h2 class="dashboard-title">Proyectos</h2>
      <button @click="goToCreateProyect" class="btn-create-project">
        <i class="fas fa-plus mr-2"></i> Agregar proyecto
      </button>
    </div>
    <div>
      <ProyectsTable></ProyectsTable>
    </div>
  </div>
</template>

<style scoped>
.btn-create-project {
  background: linear-gradient(to right, #517fa4, #243949);
  color: white;
  border: none;
  border-radius: 8px;
  padding: 8px 16px;
  font-weight: 500;
  display: flex;
  align-items: center;
  transition: all 0.3s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.btn-create-project:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.15);
}

.btn-create-project i {
  margin-right: 8px;
}
</style>
